export default [
  // Weapons
  "ar39_samurai01_shop",
  "smg49_samurai01_shop",
  "shg55_samurai01_shop",
  "sr47_samurai01_shop",
  "pt33_samurai01_shop",
  "pt39_samurai01_shop",
  "kn19_samurai01",
  "kn21_samurai01",
  "hmg03_samurai01_shop",
  "ar30_samurai02_shop",
  "ar36_samurai02_shop",
  "ar04_samurai02_shop",
  "smg38_samurai02_shop",
  "smg47_samurai02_shop",
  "smg03_samurai02_shop",
  "shg45_samurai02_shop",
  "shg50_samurai02_shop",
  "shg22_samurai02_shop",
  "sr09_samurai02_shop",
  "sr47_samurai02_shop",
  "sr03_samurai02_shop",
  "pt21_samurai02_shop",
  "pt02_samurai02_shop",
  "kn13_samurai02",
  "kn05_samurai02",

  // Skins
  "ar35_samurai01skin_shop",
  "ar39_samurai01skin_shop",
  "smg46_samurai01skin_shop",
  "smg49_samurai01skin_shop",
  "smg51_samurai01skin_shop",
  "shg54_samurai01skin_shop",
  "shg55_samurai01skin_shop",
  "sr47_samurai01skin_shop",
  "sr48_samurai01skin_shop",
  "pt33_samurai01skin_shop",
  "pt39_samurai01skin_shop",
  "kn19_samurai01skin_shop",
  "kn21_samurai01skin_shop",
  "hmg03_samurai01skin_shop",
  "ar30_samurai02skin_shop",
  "ar36_samurai02skin_shop",
  "ar04_samurai02skin_shop",
  "smg38_samurai02skin_shop",
  "smg47_samurai02skin_shop",
  "smg03_samurai02skin_shop",
  "shg45_samurai02skin_shop",
  "shg50_samurai02skin_shop",
  "shg22_samurai02skin_shop",
  "sr09_samurai02skin_shop",
  "sr47_samurai02skin_shop",
  "sr03_samurai02skin_shop",
  "pt21_samurai02skin_shop",
  "pt02_samurai02skin_shop",
  "kn13_samurai02skin_shop",
  "kn05_samurai02skin_shop",

  // Appearance
  "soldier_fbs_samurai_01",
  "medic_fbs_samurai_01",
  "engineer_fbs_samurai_01",
  "sniper_fbs_samurai_01",

  // Grenade
  "sg45_samurai01_c",
];
